<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import { api } from '@/services/ApiService'
import userStore from '@/store/UserStore'
import { useRouter } from 'vue-router'

type BrandCountryType = { brand: string, country: string }

const brandCountryCombinations = ref<BrandCountryType[]>([])
const selectedCountry = ref(`${userStore.brand}-${userStore.country}`)
const router = useRouter()

onMounted(async () => {
  const availableCountries = await api.loadAvailableAdminConfigs()
  brandCountryCombinations.value = availableCountries
    .sort((a, b) => a.brand.localeCompare(b.brand) || a.country.localeCompare(b.country))
})

async function countryChanged() {
  if (selectedCountry.value === 'reset') {
    resetCountrySwitch()
    return
  }

  const [brand, country] = selectedCountry.value.split('-')

  const keycloakConfiguration = await api.fetchKeycloakConfiguration()
  const subBrand = keycloakConfiguration.realmMapping
    .find(rm => rm.brand === brand && rm.country === country)
    ?.subBrand

  userStore.forcedCountry = country
  userStore.forcedBrand = subBrand || brand

  router.go(0)
}

function resetCountrySwitch() {
  userStore.forcedCountry = ''
  userStore.forcedBrand = ''

  router.go(0)
}
</script>

<template>
  <select v-model="selectedCountry" name="country-switcher" @change="countryChanged">
    <option v-if="userStore.forcedCountry !== '' && userStore.forcedBrand !== ''" value="reset">
      Back to original
    </option>
    <option
      v-for="brandCountry in brandCountryCombinations" :key="`${brandCountry.brand}-${brandCountry.country}`"
      :value="`${brandCountry.brand}-${brandCountry.country}`"
    >
      {{ brandCountry.brand }} - {{ brandCountry.country }}
    </option>
  </select>
</template>

<style lang="scss" scoped>
select {
  width: unset;
  appearance: unset;
  -moz-appearance: unset;
}
</style>
